enum AbrFormat {
    DASH = 'DASH',
    HLS = 'HLS',
    NONE = 'NONE',
    SMOOTHSTREAMING = 'SMOOTHSTREAMING'
}

export default AbrFormat;